<section class="resume services bg-pink" id="team">
  <div class="container">
      <div class="row">
          <div class=" offset-md-2 col-md-8">

              <div class="title title2">
                <h2 class="">team members</h2>

              </div>
          </div>
      </div>
      <div class="row" style="padding-bottom: 30px;">
        <div class="col-md-12 col-lg-12 col-sm-12">
          <h2 class="text-center">Physios</h2>
        </div>
      </div>
      <div class="row">
          <div class="col-md-6 col-lg-3 col-sm-6" *ngFor="let expert of experts">
              <div class="service text-center bg-white" style="width: 302px; height: 300px; background-image: url('{{expert.img}}'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;" onclick="">
                  <div class="service-feature">
                    <h3 class="m-b-10 heading__expert-name">{{expert?.name}}</h3>
                    <h4 class="m-b-10">{{expert?.title}}</h4>
                    <h4 class="m-b-10">{{expert?.qualificationMain}}</h4>

                  </div>
                  <div class="socials-lists" *ngIf="expert?.readMore" style="margin-top: 10px;">
                    <a class=" btn btn-default" (click)="openModal(expert)">read more</a>
                  </div>

                  </div>
              </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-3 col-sm-6" *ngFor="let support of staff">
                <div class="service text-center bg-white" style="width: 302px; height: 300px; background-image: url('{{support.img}}'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;" onclick="">
                    <div class="service-feature">
                      <h3 class="m-b-10 heading__expert-name">{{support?.name}}</h3>
                      <h4 class="m-b-10">{{support?.title}}</h4>
                      <h4 class="m-b-10">{{support?.qualificationMain}}</h4>
                    </div>
                    <div class="socials-lists" *ngIf="support?.readMore" style="margin-top: 10px;">
                      <a class=" btn btn-default" (click)="openModal(support)">read more</a>
                    </div>
                </div>
            </div>
        </div>

          <div class="row" style="padding-bottom: 30px;">
            <div class="col-md-12 col-lg-12 col-sm-12">
              <h2 class="text-center">Support staff</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-3 col-sm-6" *ngFor="let support of supports">
                <div class="service text-center bg-white" style="width: 302px; height: 300px; background-image: url('{{support.img}}'); background-size: cover; -moz-background-size: 100% 100%;-webkit-background-size: 100% 100%;background-size: 100% 100%;" onclick="">
                    <div class="service-feature">
                      <h3 class="m-b-10 heading__expert-name">{{support?.name}}</h3>
                      <h4 class="m-b-10">{{support?.title}}</h4>
                      <h4 class="m-b-10">{{support?.qualificationMain}}</h4>
                    </div>
                </div>
            </div>
        </div>
      </div>

</section>


